module.exports = __webpack_public_path__ + "img/SES_160254104.342cc932.jpg";